import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Typography } from '@mui/material';
import styles from './FileMgrBreadcrumbs.module.css';

const FileMgrBreadcrumb = ({ navHistoryStack, traverseBackDirectory }) => {
	return (
		<div className={styles.breadcrumbs}>
			<Breadcrumbs maxItems={2}>
				{navHistoryStack.map((directory, index) => {
					// If the current element is the last element, handle it differently
					if (index === navHistoryStack.length - 1) {
						// Handle the last element differently (e.g., apply a different callback)
						return (
							<Typography color="text.primary">
								{directory.name}
							</Typography>
						);
					} else {
						// Apply the regular callback for other elements
						return (
							<Typography
								key={index}
								onClick={(e) => {
									e.preventDefault();
									traverseBackDirectory(directory);
								}}
								color="inherit"
								underline="hover"
								className={styles.clickable}
							>
								{directory.name}
							</Typography>
						);
					}
				})}
			</Breadcrumbs>
		</div>
	);
};

export default FileMgrBreadcrumb;
